import {
    Component
} from '@theme/component';
export class ArticleBible extends Component {
    constructor() {
        super();
        this.bibleList = window.bibleList
        this.bibleBtnGroupEl = this.querySelector(".bible-btn-group")
        this.nextBtnEl = this.querySelector(".bible-btn-group")?.querySelector(".btn-next")
        this.prevBtnEl = this.querySelector(".bible-btn-group")?.querySelector(".btn-prev")
        this.bibleBtnGroupEl.querySelectorAll('button').forEach((btn) => {
            btn.addEventListener('click', (e) => {
                this.openLink(btn);
            });
        });
    }
    connectedCallback() {
        super.connectedCallback();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    openLink(e){
        let clickDate = e.getAttribute("data-date")
        if(this.bibleList.findIndex((item)=>item.date === clickDate) > -1){
            location.href = this.bibleList.find((item)=>item.date === clickDate).url
            return
        }
        e.getAttribute("data-type")=='prev'?location.href =this.bibleList[0].prevMonthLink:location.href =this.bibleList[0].nextMonthLink
    }
}
if (!customElements.get('article-bible')) {
    customElements.define('article-bible', ArticleBible);
}